module.exports = __webpack_public_path__ + "assets/img/101.ffe1a008.png";